import catalog from 'apis/catalog';
import { RawSubcatalogAPIData } from 'types/catalog_types';

export const allByCatalogId = async (catalogId: number) => {
  const { data } = await catalog.get<RawSubcatalogAPIData[]>(
    `/templates.json?parent_id=${catalogId}`
  );
  return data;
};
